/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_2_SolutionInputs */

const es_home_usecases_item_2_solution = /** @type {(inputs: Home_Usecases_Item_2_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscá: 'cambio alcance proyecto dashboard febrero'. Obtenés: El email específico con el hilo completo y adjuntos.`)
};

const en_home_usecases_item_2_solution = /** @type {(inputs: Home_Usecases_Item_2_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search: 'scope change dashboard project February'. Get: The specific email with the complete thread and attachments.`)
};

/**
* | output |
* | --- |
* | "Search: 'scope change dashboard project February'. Get: The specific email with the complete thread and attachments." |
*
* @param {Home_Usecases_Item_2_SolutionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_2_solution = /** @type {((inputs?: Home_Usecases_Item_2_SolutionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_2_SolutionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_2_solution(inputs)
	return en_home_usecases_item_2_solution(inputs)
});
export { home_usecases_item_2_solution as "home.usecases.item_2_solution" }